import type React from 'react';
import { OptOutModal } from './OptOutModal';

interface CreditTrackingOptOutModalProps {
  open: boolean;
  onClose: () => void;
  onOptOut: () => void;
}

export const CreditTrackingOptOutModal: React.FC<CreditTrackingOptOutModalProps> = (props) => {
  return <OptOutModal {...props} type="credit-tracking" />;
};
